import logger from './utils/logger.mjs';
import App from './App';
import { initializeNeuroApplication } from '@ignitesales/neuro-application';
import AppLoading from './AppLoading';
import messages from './i18n/messages';
import WebFont from 'webfontloader';
import analyticsReducer from './reducers/analytics-reducer';
import questionLayouts from './components/questions/containers/index.mjs';
import questionTypes from './components/questions/types/index.mjs';
import stBankNavigationReducer from "./reducers/stbankNavigationReducer";
import initState from "./utils/initState";

const init = async () => {
  WebFont.load({
    typekit: {
      id: 'lfv8frm'
    }
  });

  await initializeNeuroApplication(
    {
      AppComponent: App,
      LoadingComponent: AppLoading,
      messages,
      isBranchGuide: false,
      supportedLocales: ['en'],
      reducers: [ 
        stBankNavigationReducer,
        analyticsReducer
      ],
      questionLayouts,
      questionTypes,
      decorateStateFn: async state => {
        return await initState(state);
      }
    }
  );

  logger.info('Go for takeoff!');
};

init();
